import React from "react";
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';

/* Components ---------------------------*/
import TaxesCalculator from './../components/TaxesCalculator/TaxesCalculator';

const TaxCalculator = () => {
    return (
        <TaxCalculatorStyled className='TaxCalulator'>
            <Container>
                <h1>Tax Calculator</h1>
                <TaxesCalculator />
            </Container>
        </TaxCalculatorStyled>
    )
}

export default TaxCalculator;

const TaxCalculatorStyled = styled.div`
    h1 {
        text-align: center;
        font-size: 40px;
        padding-top: 50px;
        padding-bottom: 50px;
    }
`;